var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('node-view-wrapper', {
    staticClass: "tip-tap-custom-list-item",
    style: _vm.listStyle
  }, [_c('ol', {
    staticClass: "tip-tap-custom-list-item-pseudo-list",
    staticStyle: {
      "padding-left": "0",
      "list-style-position": "outside"
    }
  }, [_c('li', {
    class: _vm.listItemClass,
    attrs: {
      "data-number-content": _vm.formattedNumber
    }
  }, [_c('div', {
    staticClass: "tip-tap-custom-list-item-content"
  }, [_c('node-view-content', {
    staticClass: "content-dom"
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }